module.exports = __webpack_public_path__ + "static/media/22_plantilla_combo_rectangular_marco_comida_38.3fae3753.png";